import axios, { AxiosResponse } from 'axios';
import api from './api';

const maxMindApi = axios.create({
  baseURL: process.env.VUE_APP_MAXMIND_API_URL,
  headers: process.env.VUE_APP_MAXMIND_API_TOKEN,
});

const getCardFlag = async (
  cardNumber: string,
): Promise<AxiosResponse<Services.Invoice.Response.GetCardFlag>> => (
  api.get(`invoices/whatismyflag/${encodeURIComponent(cardNumber)}`)
);

const getInvoiceData = async (
  payload: Services.Invoice.GetInvoiceData,
): Promise<AxiosResponse<Services.Invoice.Response.GetInvoiceData>> => (
  api.get(`prospects/prospectinvoice/${payload.prospectId}/${payload.invoiceHash}`)
);

const getLocation = async (): Promise<AxiosResponse<Services.Invoice.Response.GetLocation>> => (
  maxMindApi.get('mylocation')
);

const postPayment = async (payload: Services.Invoice.PostPayment) => (
  api.post('prospects/prospectinvoice', payload)
);

export default {
  getCardFlag,
  getInvoiceData,
  getLocation,
  postPayment,
};
